import { makeStyles } from "@material-ui/core";
import clsx from "clsx";
import React from "react";
import { tabAccentEdgeWidth, tabSize } from "../../config";
import { Tooltip } from "antd";

const useStyles = makeStyles((theme) => ({
  base: {
    width: `${tabSize}px`,
    height: `${tabSize}px`,
    borderColor: "var(--borderColor)",
    borderWidth: "0px 1px 1px 1px",
    borderStyle: "solid",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
  },
  disabled: {
    pointerEvents: "none",
    color: "var(--borderColor)",
  },
  active: {
    borderRight: "1px solid white",
    borderLeft: "1px solid var(--accentColor)",
    "&::before": {
      content: '""',
      position: "absolute",
      borderLeft: `${tabAccentEdgeWidth}px solid var(--accentColor)`,
      width: `${tabSize}px`,
      height: `${tabSize + 2}px`,
      transform: `translateX(-${tabAccentEdgeWidth - 2}px)`,
      borderRadius: `${tabAccentEdgeWidth - 1}px`,
    },
  },
}));

function Tab({ children, label, active, disabled, ...rest }) {
  const classes = useStyles();
  const tooltip = label;
  return (
    <Tooltip title={tooltip} placement="left">
      <div
        disabled={disabled}
        className={clsx({
          [classes.base]: true,
          [classes.active]: active,
          [classes.disabled]: disabled,
        })}
        {...rest}
      >
        {children}
      </div>
    </Tooltip>
  );
}

export default Tab;
